export default "__VITE_ASSET__bcecf2d2__"